import createVueComponent from '../createVueComponent';

const Layout = createVueComponent('LayoutIcon', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['line', { x1: '3', x2: '21', y1: '9', y2: '9', key: '1vqk6q' }],
  ['line', { x1: '9', x2: '9', y1: '21', y2: '9', key: 'wpwpyp' }],
]);

export default Layout;
